import React, { createContext, useContext, useMemo } from 'react';
import { IAdTagResponce } from '@pages/Root/services/api/ads/ad-model-definitions.ts';
import { AdSourceType } from '@pages/Root/ContextWrapper/WithInterest/WithCommonPageData.tsx';

export interface IAdsContext {
  isReady: boolean;
  adConfigData: IAdTagResponce | null;
  adSource: AdSourceType;
  // Identifies the effective {brandGroupId, utmSource}. Slots currently remount on a config change
  // because isReady flips to false while the new scripts load; this is exposed for consumers that
  // need to react to the change explicitly.
  configKey?: string;
}

export const AdsContext = createContext<IAdsContext | undefined>(undefined);

export const useAds = (): IAdsContext => {
  const context = useContext(AdsContext);
  if (!context) {
    throw new Error('useAds must be used within an AdsProvider from AdsLayout');
  }

  // CMBU-2041: Force GAM ads on fotoscapes.com
  // Override the adSource if hostname includes 'fotoscapes.com'
  const adSource = useMemo(() => {
    if (
      typeof window !== 'undefined' &&
      window.location?.hostname?.includes('fotoscapes.com')
    ) {
      return 'gam';
    }
    return context.adSource;
  }, [context.adSource]);

  return {
    ...context,
    adSource,
  };
};
